export default class GeneralError extends Error {
}
